import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Subject} from 'rxjs';
import {Router} from '@angular/router';
import {BASE_API_URL} from '../../app.globals';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private isAuth = false;
  private token;
  private expiresIn;
  private accessLevel;
  private tokenTimer;
  userId;
  private userName;
  authStatusListener = new Subject<boolean>();

  constructor(private http: HttpClient, private router: Router) {
  }

  getAuthStatusListener() {
    return this.authStatusListener.asObservable();
  }
  getIsAuth() {
    return this.isAuth;
  }
  getUserId() {
    return this.userId;
  }
  getUserName() {
    return this.userName;
  }
  getAccessLevel() {
    return this.accessLevel;
  }
  getToken() {
    return this.token;
  }
  getTimer() {
    const now = new Date();
    const expDate = new Date(now.getTime() + this.expiresIn * 1000);
    return expDate;
  }
  getAuthInfo() {
    return this.getAuthData();
  }
  login(user) {
    this.http.post<{ token: string, expiresIn: number, user}>(BASE_API_URL + 'login', user)
      .subscribe(response => {
        const token = response.token;
        this.token = token;
        if (token) {
          const tokenDuration = response.expiresIn;
          this.expiresIn = tokenDuration;
          const accessLevel = response.user.accessLevel;
          this.accessLevel = accessLevel;
          const userId = response.user.personId;
          const userName = response.user.displayName;
          this.userName = userName;
          this.userId = userId;
          this.setAuthTimer(tokenDuration);
          this.isAuth = true;
          this.authStatusListener.next(true);
          const now = new Date();
          const expDate = new Date(now.getTime() + tokenDuration * 1000);
          console.log('EXP IN', this.expiresIn);
          this.saveAuthData(token, expDate, accessLevel, userId, userName);
          this.router.navigate(['/app']);
        }
      });
  }

  autoAuthUser() {
    const authInfo = this.getAuthData();
    if (!authInfo) {
      return;
    }
    const now = new Date();
    const expiresIn = authInfo.expDate.getTime() - now.getTime();
    this.expiresIn = expiresIn;
    if (expiresIn > 0) {
      this.token = authInfo.token;
      this.isAuth = true;
      this.userId = authInfo.userId;
      this.setAuthTimer(expiresIn / 1000);
      this.authStatusListener.next(true);
    }
  }
  logout() {
    this.token = null;
    this.isAuth = false;
    this.authStatusListener.next(false);
    clearTimeout(this.tokenTimer);
    this.removeAuthData();
    this.router.navigate(['/login']);
  }
  private setAuthTimer(duration: number) {
    this.tokenTimer = setTimeout(() => {
      this.logout();
    }, duration * 1000);
  }
  private saveAuthData(token: string, expDate: Date, accessLevel: string, userId: string, userName: string) {
    localStorage.setItem('token', token);
    localStorage.setItem('expires', expDate.toISOString());
    localStorage.setItem('access', accessLevel);
    localStorage.setItem('userId', userId);
    localStorage.setItem('userName', userName);
  }

  private removeAuthData() {
    localStorage.removeItem('token');
    localStorage.removeItem('expires');
    localStorage.removeItem('access');
    localStorage.removeItem('userId');
    localStorage.removeItem('userName');
  }
  private getAuthData() {
    const token = localStorage.getItem('token');
    const expDate = localStorage.getItem('expires');
    const userId = localStorage.getItem('userId');
    const accessLevel = localStorage.getItem('access');
    const userName = localStorage.getItem('userName');
    if (!token || !expDate) {
      return;
    }
    return {
      token,
      expDate: new Date(expDate),
      userId,
      userName,
      accessLevel
    };
  }
}

